module.exports = __webpack_public_path__ + "img/app-settings.e0414def.svg";